import { Cookies } from 'react-cookie';

import { EncounterCreateFormValues } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export interface PostEncounterOnMapProps {
  encounter: EncounterCreateFormValues;
  objectSlug: string;
}

export const postEncounterOnMap = async ({ encounter, objectSlug }: PostEncounterOnMapProps) => {
  const formData = new FormData();

  Object.keys(encounter).forEach(key => {
    if (key !== 'photos' && encounter[key] !== null) {
      formData.append(key, encounter[key]);
    }
  });

  if (encounter.photos && encounter.photos.length > 0) {
    encounter.photos.forEach((file: File) => {
      formData.append('photos', file);
    });
  }
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');

  const data = await axiosInterceptor.post(`/encounters/${objectSlug}/`, formData, {
    headers: {
      Authorization: token,
      'Content-Type': 'multipart/form-data',
    },
  });

  return data.data as any;
};
